import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';


// data imports
import { draggableClass } from 'logic/data/Izenda.ReportPartKPIConstants.js';

// share dependencies
import Chart from 'share/components/charting/Izenda.Chart';
import connect from 'share/enhancers/Izenda.Connect';
import { parser as chartDataParser } from 'share/utils/Izenda.ChartDataParser';
import ReportPartUtils from 'share/utils/Izenda.ReportPartUtils';

// Local dependencies
import actions from './Izenda.KPIFrontSideActions';


@connect(actions)
class KPIPreview extends Component {
  static propTypes = {
    store: PropTypes.object,
    reportPart: PropTypes.object.isRequired
  };

  componentWillUnmount() {
    this.props.refreshData && this.props.refreshData(false);
  }


  render() {
    const {
      props,
      props: {
        isBorderConfig,
        viewMode,
        reportPart,
        printingMode,
        reportPart: { reportPartContent }
      }
    } = this;

    let chartProperties = toJS(reportPart.getReportPartProperties()) || {};
    let doesBreakPage = reportPartContent.checkBreakPage();
    const type = reportPartContent.type;

    let chartData = chartDataParser(
      reportPartContent.activeElmsByContainers,
      reportPartContent.expandedLevel,
      {
        fieldsMapping: reportPart.previewDataFieldsMapping,
        records: reportPart.previewDataRecords,
        rawData: reportPart.previewData
      },
      null
    );

    $izenda.extend(true, chartProperties, {
      colors: reportPart.getThemeColors(chartProperties),
      commonActions: {
        setPageSize: props.setPageSize,
        pointAction: props.pointAction
      },
      optionsByType: {
        isBorderConfig
      }
    });

    // refresh data intervals
    props.refreshData && props.refreshData(true);

    if (ReportPartUtils.needToRenderLazyLoadingBar(reportPart, printingMode)) {
      return ReportPartUtils.renderLazyLoadingBar();
    }

    return (
      <Chart
        type={type}
        reportPart={reportPart}
        isPreview={props.isPreview}
        chartType={chartProperties.chartType}
        chartOptions={chartProperties}
        className={draggableClass}
        seriesOptions={props.reportPart.fieldCollection}
        chartData={chartData}
        printingMode={printingMode}
        doesBreakPage={!props.forDashboard && doesBreakPage && !props.embededReportPart}
        gaugePartType
        viewMode={viewMode}
        style={printingMode && props.style ? props.style : {}}
        finishedRender={props.finishedRender}
        fulfilledData={props.fulfilledData}
        isLoading={reportPart.isLoadingData}
        separator={props.separator}
        forExporting={props.forExporting}
        vizEngine={reportPartContent.vizEngine}
      >
        {/* {!printingMode && (
          <ChartToolbar
            reportPart={reportPart}
            onDrillDown={props.onDrilldown}
            isShowMetric={reportPartContent.isShowMetric}
          />
        )} */}
      </Chart>
    );
  }
}

export default KPIPreview;


// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartKPI/Izenda.KPIPreview.jsx